import React from "react";
import { Box, Typography, Paper, List, ListItem, ListItemIcon, ListItemText, Button, Grid } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const resources = [
  { label: "Tools", href: "https://drive.google.com/file/d/186as3sWqZ1otf7FIvIY1DZLnspIZueCP/view?usp=sharing" },
];

const bonuses = [
  { label: "Bonuses", href: "https://drive.google.com/file/d/1MnsXsQwrE5WqQHSm8La-bQL553VFvnM9/view?usp=sharing" },
];

export default function Resources() {
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={4}>
        {/* Tools section (full width), with image on the right */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, bgcolor: "custom.beige" }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={7}>
                <Box display="flex" alignItems="center" mb={2}>
                  <Box component="img" src="/assets/cyj-logo.jpeg" alt="Craft Your Journey" sx={{ width: 48, height: 48, mr: 2 }} />
                  <Typography variant="h5" color="text.primary">Craft Your Journey Tools</Typography>
                </Box>
                <Typography variant="body1" color="text.secondary" mb={2}>Download the practical templates and guides.</Typography>
                <List>
                  {resources.map((r) => (
                    <ListItem key={r.label} component="a" href={r.href} target="_blank" rel="noopener noreferrer" sx={{ color: "text.primary" }}>
                      <ListItemIcon>
                        <PictureAsPdfIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary={r.label} />
                    </ListItem>
                  ))}
                </List>
              </Grid>
              <Grid item xs={12} md={5}>
                <Box
                  component="img"
                  src="/assets/cyj-ebook-chapter-bundle.png"
                  alt="Tools Preview"
                  sx={{ width: "100%", height: { xs: 180, md: 260 }, objectFit: "contain" }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Bonuses section (full width), with image on the left */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, bgcolor: "custom.beige" }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={5}>
                <Box
                  component="img"
                  src="/assets/bonuses-weekly-rewards.png"
                  alt="Bonuses Preview"
                  sx={{ width: "100%", height: { xs: 180, md: 260 }, objectFit: "cover", borderRadius: 2 }}
                />
              </Grid>
              <Grid item xs={12} md={7}>
                <Box display="flex" alignItems="center" mb={2}>
                  <Box component="img" src="/assets/cyj-logo.jpeg" alt="Craft Your Journey" sx={{ width: 48, height: 48, mr: 2 }} />
                  <Typography variant="h5" color="text.primary">Craft Your Journey Bonuses</Typography>
                </Box>
                <Typography variant="body1" color="text.secondary" mb={2}>Extra resources to deepen your journey.</Typography>
                <List>
                  {bonuses.map((b) => (
                    <ListItem key={b.label} component="a" href={b.href} target="_blank" rel="noopener noreferrer" sx={{ color: "text.primary" }}>
                      <ListItemIcon>
                        <PictureAsPdfIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText primary={b.label} />
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Quote section */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, bgcolor: "background.paper", textAlign: "center" }}>
            <Box sx={{ borderLeft: 6, borderColor: "primary.main", pl: { xs: 2, md: 3 }, maxWidth: 900, mx: "auto", textAlign: "left" }}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                “It’s Not Just Pretty Pages, It’s Life-Changing Practice.”
              </Typography>
              <Typography variant="body1" color="text.secondary" paragraph>
                Every page, prompt, and printable has been designed with one purpose: to make emotional growth easy, joyful, and real for your family.
              </Typography>
              <Typography variant="body1" color="text.primary" paragraph>
                You just said yes to raising your child with more calm, confidence, and heart.
                You didn’t buy a book. You invested in moments that will shape how your child feels loved, seen, and safe for life.
              </Typography>
              <Typography variant="body1" color="text.primary" paragraph>
                That’s powerful. That’s parenting on purpose.
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" fontStyle="italic">
                — Sara Hafez, MSc in Positive Psychology (UK)
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Community section */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, bgcolor: "custom.blue", color: "common.white", textAlign: "center" }}>
            <Typography variant="h5" gutterBottom>
              Join Our Community and Transform Your Life Today!
            </Typography>
            <Typography variant="body1" paragraph>
              Join our Private Parenting Circle, a free, heart-led community for parents who want to raise emotionally strong kids together.
            </Typography>
            <Typography variant="body1" gutterBottom>
              You’ll get…
            </Typography>
            <Box sx={{ display: "inline-block", textAlign: "left" }}>
              <List sx={{ color: "common.white" }}>
                <ListItem>
                  <ListItemText primary="Exclusive weekly insights & bonus practices from Sara" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Real stories from other parents walking this same journey" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Space to ask questions, share wins, and stay inspired" />
                </ListItem>
              </List>
            </Box>
            <Box mt={2}>
              <Button variant="contained" bgcolor="custom.blue" href="https://chat.whatsapp.com/H2aqVIWLJQu1BkIA664xMV?mode=hqrc" target="_blank" rel="noopener noreferrer">
                Join The Community Here
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
